import { QueryClient } from '@tanstack/react-query';
import { client } from '@refly-packages/ai-workspace-common/requests';
import { responseInterceptorWithTokenRefresh } from '@refly-packages/ai-workspace-common/utils/auth';
import { isDesktop, serverOrigin } from '@refly/ui-kit';

// Add /AIMflyV1 prefix for web requests (not for desktop)
const apiBaseUrl = `${serverOrigin}/v1`;

client.setConfig({
  baseUrl: apiBaseUrl,
  credentials: isDesktop() ? 'omit' : 'include',
  throwOnError: false, // If you want to handle errors on `onError` callback of `useQuery` and `useMutation`, set this to `true`
});

client.interceptors.response.use(async (response, request) => {
  return responseInterceptorWithTokenRefresh(response, request);
});

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // 关闭「窗口重新聚焦即 refetch」的默认行为：切回标签页时会把仍在飞行中的同名请求
      // abort，浏览器 console 里表现为 net::ERR_ABORTED（如 /v1/auth/config、/v1/provider/item/list）。
      // 个别确实需要聚焦刷新的查询仍可在各自 hook 里显式覆盖为 true。
      refetchOnWindowFocus: false,
    },
  },
});
